module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800x2-5bef369665ef41dee4ace3d49a0f0af8.webp";